import { render, staticRenderFns } from "./paragraph.vue?vue&type=template&id=d94347f8&scoped=true&"
import script from "./paragraph.vue?vue&type=script&lang=js&"
export * from "./paragraph.vue?vue&type=script&lang=js&"
import style0 from "./paragraph.vue?vue&type=style&index=0&id=d94347f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94347f8",
  null
  
)

export default component.exports